import script from "./TaxSetupStep.vue?vue&type=script&setup=true&lang=ts"
export * from "./TaxSetupStep.vue?vue&type=script&setup=true&lang=ts"

import "./TaxSetupStep.vue?vue&type=style&index=0&id=3bd60d2a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3bd60d2a"]])

export default __exports__